<template>
  <view>
    <view class="custom-view" v-if="messageData.type == 'TextAppendArgument'">
      <view class="content-view">{{ content }}</view>
      <view v-if="textArray.length" class="text-list">
        <view class="text-item" v-for="(text, index) in textArray" :key="index">
          {{ text.argumentDesc }}
        </view>
      </view>
    </view>
    <!-- 订单卡片：小程序「引用订单」发来的自定义消息（businessID='order'，协议见
         mall_mini/src/utils/imOrderCard.js）。与欢迎语分支并列（v-else-if），判定只看 businessID，
         那条 type=='TextAppendArgument' 原样不动——两条判定互不干扰。
         这一层用 div/img：工作台是 Web 端，语义化标签才好套既有气泡样式 -->
    <div v-else-if="isOrderCard" class="order-card">
      <img v-if="orderCard.imageUrl" class="order-card-thumb" :src="orderCard.imageUrl" alt="商品图">
      <div v-else class="order-card-thumb order-card-thumb-empty"></div>
      <div class="order-card-main">
        <h1 class="order-card-title">{{ orderCard.title || '订单商品' }}</h1>
        <p v-if="orderCard.orderId" class="order-card-no">订单号 {{ orderCard.orderId }}</p>
        <p class="order-card-status">
          <span>{{ orderCard.statusText || orderCard.status || '订单' }}</span>
          <span v-if="orderCard.quantity"> · 共 {{ orderCard.quantity }} 件</span>
        </p>
        <span v-if="orderCard.price" class="order-card-price">{{ orderCard.price }}</span>
      </div>
    </div>
  </view>
</template>

<script>
/**
 * 字段统一成字符串：卡片字段缺失（undefined/null）时给空串，模板据此隐藏对应行，
 * 不让一个缺失字段把整条消息变成空白（历史里一条脏数据不该顶掉整条会话的渲染）。
 */
function asText(value) {
  if (value === null || value === undefined) return ''
  const text = String(value).trim()
  return text === 'undefined' || text === 'null' ? '' : text
}

export default {
  props: {
    messageItem: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  computed: {
    // 消息内容
    messageData() {
      let data = ''
      if (this.messageItem?.c2cId) {
        data = this.messageItem?.payload?.MsgContent?.Data;
      } else {
        data = this.messageItem?.payload?.data;
      }
      return data ? JSON.parse(data) : {};
    },
    // 欢迎语
    content() {
      return this.messageData.content;
    },
    // 问题列表
    textArray() {
      return this.messageData.text
    },
    /**
     * 订单卡片数据：只认 businessID==='order'（与小程序端 utils/imOrderCard.js 同一协议），
     * 其它自定义消息一律返回 null，交回既有分支处理。
     * 直接复用 messageData：它在 c2cId 存在时取 MsgContent.Data、否则取 payload.data，
     * 两条来源已经由它兜住，这里不再重复一遍（重复解析反而会与它走岔）。
     */
    orderCard() {
      const data = this.messageData || {}
      if (String(data.businessID) !== 'order') return null
      const quantity = Number(data.quantity)
      return {
        orderId: asText(data.orderId),
        imageUrl: asText(data.imageUrl),
        title: asText(data.title),
        price: asText(data.price),
        status: asText(data.status),
        statusText: asText(data.statusText),
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 0,
      }
    },
    isOrderCard() {
      return this.orderCard !== null
    }
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
.custom-view {
  box-sizing: border-box;
  background: #dceafd;
  border-radius: 10px 0 10px 10px;
  .content-view {
    font-weight: bold;
    font-size: 30rpx;
    color: #000;
  }
  .text-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .text-item {
      margin-top: 10rpx;
      font-size: 28rpx;
      color: #2F7CFE;
    }
  }
}
/* ---------- 订单卡片 ---------- */
/* 单位用 px 而不是上面欢迎语那几条里的 rpx：im_client 是 Web 工程，没有 rpx 转换插件
   （vue.config.js 里只有 devServer 代理，无 postcss），rpx 声明会被浏览器当非法值丢掉。
   上面既有的 rpx 规则**刻意不动**——改它们会改变欢迎语卡片的渲染结果。
   宽度给 320px 且 max-width:100%：长商品名靠 line-clamp 折两行，不把气泡撑破消息列表 */
.order-card {
  display: flex;
  box-sizing: border-box;
  width: 320px;
  max-width: 100%;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  text-align: left;
}
.order-card-thumb {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 6px;
  object-fit: cover;
  background: #f0f0f0;
}
/* 缺图占位底：与缩略图同尺寸，卡片结构不塌 */
.order-card-thumb-empty {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 6px;
  background: #f0f0f0;
}
.order-card-main {
  flex: 1;
  min-width: 0;
  margin-left: 10px;
}
.order-card-title {
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #222;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.order-card-no {
  margin: 4px 0 0;
  font-size: 12px;
  color: #999;
  word-break: break-all;
}
.order-card-status {
  margin: 4px 0 0;
  font-size: 12px;
  color: #666;
}
.order-card-price {
  display: inline-block;
  margin-top: 6px;
  font-size: 14px;
  color: #ff7201;
}
</style>